export default "__VITE_ASSET__ClUvhDpn__"